var classes = {"productCardContainer":"UJheV"};

export { classes as default };
